import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ImportAnnotationsBl } from '../../../importAnnotations.bl';
import { IImportAnnotationsStore } from '../../../importAnnotations.store';
import { ImportAnnotationsStep } from '../../../models/ImportAnnotationsSteps';
import { ResolveConflictsStepModal } from './ResolveConflictsStepModal';

export const ResolveConflictsStepContainer = observer((): ReactElement => {
  const bl = useInjection(ImportAnnotationsBl.$);
  const store = useInjection(IImportAnnotationsStore.$);

  const handleHide = (): void => {
    bl.cancelImport();
  };

  const handleSubmit = async (): Promise<void> => {
    await bl.importAnnotationsAsync();
  };

  const handleKeepAll = (): void => {
    bl.keepAllAnnotations();
  };
  const handleReplaceAll = (): void => {
    bl.replaceAllAnnotations();
  };

  const isCurrentStep = store.currentStep === ImportAnnotationsStep.ResolveConflicts;

  return (
    <ResolveConflictsStepModal
      show={isCurrentStep}
      onHide={handleHide}
      onSubmit={handleSubmit}
      conflicts={store.conflicts}
      keepAll={handleKeepAll}
      replaceAll={handleReplaceAll}
    />
  );
});
